<div class="booking-checkout-details">
  <div class="booking-checkout-details__row">
    <span class="booking-checkout-details__item">{{ 'calendar-check-in' | translate }}</span>
    <span class="booking-checkout-details__item">{{ selectedDatesLabel.split('-')[0] }}</span>
  </div>
  <div class="booking-checkout-details__row">
    <span class="booking-checkout-details__item">{{ 'calendar-check-out' | translate }}</span>
    <span class="booking-checkout-details__item"> {{ selectedDatesLabel.split('-')[1] }}</span>
  </div>
  <div class="booking-checkout-details__row">
    <span class="booking-checkout-details__item">{{ 'booking-widget-guests' | translate }}</span>
    <span class="booking-checkout-details__item">{{ guests }}</span>
  </div>
</div>
